import { createAction, props } from '@ngrx/store';

import { ApplicationHistory } from '@shared/models/application-history';

export const applicationHistoryGet = createAction(
  '[Application History] Get Application History',
  props<{ associationId: number }>(),
);

export const applicationHistoryGetSuccess = createAction(
  '[Application History] Get Application History Success',
  props<{ associationId: number; history: ApplicationHistory[] }>(),
);

export const applicationHistoryGetFailure = createAction(
  '[Application History] Get Application History Failure',
  props<{ error: any }>(),
);
